import 'css-chunksrc/client/pages/projectPage/exportsPage/dailyPlanningReport/styles.scss';export default {
  "dailyPlanningReport": "_dailyPlanningReport_1jrt8_1",
  "checked": "_checked_1jrt8_7",
  "row": "_row_1jrt8_11",
  "checkbox": "_checkbox_1jrt8_20",
  "col": "_col_1jrt8_26",
  "name": "_name_1jrt8_30",
  "description": "_description_1jrt8_37",
  "button": "_button_1jrt8_42",
  "filters": "_filters_1jrt8_46",
  "group": "_group_1jrt8_55",
  "label": "_label_1jrt8_64",
  "columns": "_columns_1jrt8_71",
  "columnsList": "_columnsList_1jrt8_78",
  "columnItem": "_columnItem_1jrt8_87",
  "columnLabel": "_columnLabel_1jrt8_96"
};